<template>
  <div ref="scrollContainer" id="page-panel" class="box grow" >
    <div class="customer-top-nav no-print">
      <div class="title">
        <span>{{$t('settings.cmsSettings.title')}}</span>
      </div>
    </div>
    <el-tabs type="border-card">
       <el-tab-pane label="Classes clients" :lazy="true" class="box grow scrollable" :style="getHeightStyle">
        <CustomerClassController></CustomerClassController>
      </el-tab-pane>  
      <el-tab-pane label="Type de produits" :lazy="true" class="box grow scrollable" :style="getHeightStyle">
      <ProductTypesController></ProductTypesController>
      </el-tab-pane>
      <el-tab-pane label="Fiches techniques" :lazy="true" class="box grow scrollable" :style="getHeightStyle">
        <SpecificationByProductType></SpecificationByProductType>
      </el-tab-pane>
     
    </el-tabs>
  </div>
</template>
<script>

import SpecificationByProductType from './components/specification-by-product-type'
import ProductTypesController from './components/product-type-controller'
import CustomerClassController from './components/customer-class-controller'

export default {
  name: 'CMSSettings',

  data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },components: {
    SpecificationByProductType,
    ProductTypesController,
    CustomerClassController
  },
	methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
	},
	computed: {
    getHeight(){
      return (this.window.height-270);
    },
    getHeightStyle(){
      return "height:" + this.getHeight + "px;";
    },
	},
  mounted(){

  },
  created(){
    this.handleResize();
  },
  destroyed() {

  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}
.active{
  background-color: lighten($background-color, 20%);
  border-radius: 5px;
  box-shadow:none;
  box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
}

.item-list {
  //margin: 0 auto;
  width: 100%;
  // padding: 0px 30px;
  box-sizing: border-box;

  .item {
    margin: 10px 0;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .5s .25s;


    .info {
      word-break: break-word;

    }

    &:hover {
      //margin: 15px -20px;
      //padding: 10px;
      background-color: lighten($background-color, 20%);
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

    }

  }
}

@media (max-width: 1024px) {

	#page-panel{
		padding:0px;
		margin:0px;
	}

	.customer-top-nav{
		height:60px;
		padding-top:10px;
		padding-left:10px;
		padding-right:10px;
	}

}

</style>
